// extracted by mini-css-extract-plugin
export var active = "_d2-c";
export var compactArrow = "_d2-5";
export var container = "_d2-0";
export var dot = "_d2-b";
export var dotContainer = "_d2-a";
export var hoverArrowButton = "_d2-7";
export var hoverArrowContainer = "_d2-6";
export var leftHoverArrowContainer = "_d2-8 _d2-6";
export var rightHoverArrowContainer = "_d2-9 _d2-6";
export var slide = "_d2-4";
export var sliderContainer = "_d2-1";
export var sliderContainerVisibleOverflow = "_d2-2";
export var sliderOverflow = "_d2-3";
export var vignetteBoth = "_d2-f";
export var vignetteLeft = "_d2-e";
export var vignetteRight = "_d2-d";